import React from 'react';
import { styled } from '@compiled/react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { ContentTypeClassificationProps } from '../src/ContentTypeClassification/ContentTypeClassification.tsx';

export const ContentTypeClassificationLoader: LoadableType<ContentTypeClassificationProps> =
	LoadableAfterPaint<ContentTypeClassificationProps>({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentTypeClassification" */ '../src/ContentTypeClassification/ContentTypeClassification.tsx'
				)
			).ContentTypeClassification,
		loading: (props: ContentTypeClassificationProps) => {
			const { contentClassificationMetadata } = props;
			const { hasNoClassification } = contentClassificationMetadata;
			const shouldNotRenderLoader = hasNoClassification;
			if (shouldNotRenderLoader) return null;
			return React.createElement(
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
				styled.div({
					height: '24px',
				}),
				{},
				'',
			);
		},
	});

// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { ContentTypeClassification } from '../src/ContentTypeClassification/ContentTypeClassification.tsx';
